import { render, staticRenderFns } from "./vChat.vue?vue&type=template&id=2aae278f&scoped=true"
import script from "./vChat.vue?vue&type=script&lang=js"
export * from "./vChat.vue?vue&type=script&lang=js"
import style0 from "./vChat.vue?vue&type=style&index=0&id=2aae278f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae278f",
  null
  
)

export default component.exports